import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const SharedToast = ({ name }) => (
  <PositiveToast className="aridhia-shared-toast" icon="share alternate">
    <FormattedMessage id="toast.shared" values={{ name }} />
  </PositiveToast>
);

export default SharedToast;
